// navigation/mobile/floating/NavigationButtons.tsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavButton from "./NavButton";
import CartButton from "./CartButton";
import styles from "./NavigationButtons.module.scss";
import { useMobileButtons } from "../../useNavButtons";

export default function FloatingNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const navButtons = useMobileButtons();

  return (
    <div className={styles.container}>
      <div className={styles.floatingPlate}>
        {navButtons.map((button) => (
          <NavButton
            key={button.path || "service"}
            icon={button.icon}
            onClick={button.onClick || (() => navigate(button.path))}
            label={button.label}
            isActive={button.path ? location.pathname === button.path : false}
          />
        ))}
        <CartButton />
      </div>
    </div>
  );
}
